import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Card, CardContent, CardHeader, Stack, Tooltip, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const propTypes = {
  sampleData: PropTypes.shape({
    sample_1: PropTypes.shape({
      name: PropTypes.string,
      average: PropTypes.number,
      count: PropTypes.number,
      wday: PropTypes.string.isRequired,
    }),

    sample_2: PropTypes.shape({
      name: PropTypes.string,
      average: PropTypes.number,
      count: PropTypes.number,
      wday: PropTypes.string.isRequired,
    }),
  }),
}

const defaultProps = {

}

const DeliveryDetailAverageSamples = (props) => {
  const { sample_1, sample_2 } = props.sampleData;

  return (
    <Card>
      <CardHeader title="Promedio de entrega de ordenes" titleTypographyProps={{ variant: 'h6' }} />
      <CardContent>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ '& > div': { flex: 1 } }}>
        <div>
          
          <p className='flex mb12'>
            <strong>Sample 1</strong>
            <Tooltip title={
              <ul className="p0 m0">
                <li>{ sample_1.wday }</li>
                <li>Muestra: { sample_1.count }</li>
                <li>Fully allocated</li>
                <li>Lunes</li>
                <li>2 a 3 días hábiles</li>
                <li>Paid</li>
              </ul>
            }>
              <HelpOutlineIcon fontSize="small" />
            </Tooltip>
          </p>

          <Typography variant="h5">
            { sample_1.average || 0.0 }
          </Typography>
        </div>

        <div>
          
          <p className='flex mb12'>
            <strong>Sample 2</strong>
            <Tooltip title={
              <ul className="p0 m0">
                <li>{ sample_2.wday }</li>
                <li>Muestra: { sample_2.count }</li>
                <li>No stock allocated or partially allocated</li>
                <li>Lunes</li>
                <li>3 a 5 días hábiles</li>
                <li>Paid</li>
              </ul>
            }>
              <HelpOutlineIcon fontSize="small" />
            </Tooltip>
          </p>


          <Typography variant="h5">
            { sample_2.average || 0 }
          </Typography>
        </div>
      </Stack>
      </CardContent>
    </Card>
  )
};

DeliveryDetailAverageSamples.propTypes = propTypes;
DeliveryDetailAverageSamples.defaultProps = defaultProps;

export default DeliveryDetailAverageSamples;